var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"down_icon",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"max-icon",attrs:{"src":require("@/assets/svg/top-max.svg")}}),_c('img',{staticClass:"min-icon",staticStyle:{"position":"absolute","left":"18px"},attrs:{"src":require("@/assets/svg/top-min.svg")},on:{"click":_vm.prevSlide}})])
}
var staticRenderFns = []

export { render, staticRenderFns }